import { Action } from '@weblite/logic-toolkit'
import { connectionStatusView } from '$comp/main/root.reducer'
import { dispatchSetConnectionStatus } from '$comp/main/root.action'
import { setMessagesAreSynced } from '$logic/message'
import { sendSocketDisconnectedEventToWapps } from '$logic/wapp-subscribed-topics'

export const socketDisconnectedAction = new Action<void>()

export default () => {
  // NOTE: To avoid sending multiple disconnection events to wapps
  // NOTE: Call order is IMPORTANT! DO NOT MODIFY!
  if (connectionStatusView() !== 'connecting')
    sendSocketDisconnectedEventToWapps()

  setMessagesAreSynced(false)
  dispatchSetConnectionStatus('connecting')

  socketDisconnectedAction.invoke()
}
